import { request } from '@/lib/http';
import { type LoginRequest, sessaoSchema, type TrocarSenhaRequest } from '@fiscoai/contracts';

export function entrarComSenha(dados: LoginRequest) {
  return request('/auth/login', { method: 'POST', body: dados, schema: sessaoSchema, auth: false });
}

/** Troca a própria senha; devolve uma sessão nova (as outras são encerradas no servidor). */
export function trocarSenha(dados: TrocarSenhaRequest) {
  return request('/auth/senha', { method: 'POST', body: dados, schema: sessaoSchema });
}
